import { useTranslation } from "react-i18next";
import TitleWithTooltip from "src/common/components/TitleWithTooltip/TitleWithTooltip";

type Props = {
  thumbnailUrl?: string;
};

export const ThumbnailSelectedForPublication = ({ thumbnailUrl }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center w-full gap-1">
      <TitleWithTooltip
        title={t("pages.projectGroup.publish.confirmationBeforePublish.selectedThumbnail")}
        tooltip={
          <span style={{ whiteSpace: "pre-line" }}>
            {`${t("tooltip.thumbnailExplanation")}\n${t("tooltip.thumbnailExplanation2")}`}
          </span>
        }
        className="font-semibold"
      />

      {thumbnailUrl ? (
        <div className="relative w-40 h-32 bg-black rounded-xl border-4 border-green-500 overflow-hidden flex-shrink-0">
          <img
            src={thumbnailUrl}
            alt="Thumbnail"
            className="absolute inset-0 w-full h-full object-cover m-auto"
            loading="lazy"
          />
        </div>
      ) : (
        <div className="flex items-center justify-center w-40 h-32 bg-gray-100 rounded-xl border-2 border-dashed border-gray-400 text-gray-500">
          <span>{t("general.none")}</span>
        </div>
      )}
    </div>
  );
};

export default ThumbnailSelectedForPublication;
